import graphql__e9c568b38f902206e746 from "./__generated__/SlideOverlay_slide.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { useNavigateTo } from "../Routes/RoutesContext";
import Button from "../Buttons/Button";
import { hasHtmlContent, cleanHtml } from "../Utils/htmlStringUtils";
import { colorAndOpacityToRGBA } from "../Utils/colorUtils";

const SlideOverlay = props => {
  const {
    url,
    enableOverlay,
    overlayContent,
    overlayButtonText,
    overlayContentPosition,
    overlayContentTextColor,
    overlayButtonBackgroundColor,
    overlayButtonTextColor,
    overlayBackgroundColor,
    overlayOpacity
  } = useFragment(SlideOverlay_slide, props.slide);

  const navigateTo = useNavigateTo();
  const onClick = useCallback(() => navigateTo(url), [navigateTo, url]);

  if (!enableOverlay) return null;

  const text = hasHtmlContent(overlayContent) && (
    <div
      className="slide-overlay-text text-title-main-opening text-center"
      style={{ color: overlayContentTextColor }}
      dangerouslySetInnerHTML={{ __html: cleanHtml(overlayContent) }}
    />
  );

  const buttonClassName = classNames([
    "slide-overlay-button",
    "btn",
    "btn-primary",
    { "margin-top-sm": text }
  ]);

  const button = hasHtmlContent(overlayButtonText) && (
    <Button
      onClick={onClick}
      className={buttonClassName}
      label={cleanHtml(overlayButtonText)}
      style={{
        color: overlayButtonTextColor,
        backgroundColor: overlayButtonBackgroundColor
      }}
    />
  );

  const justifyContent =
    (overlayContentPosition === "middle" && "center") ||
    (overlayContentPosition === "top" && "start") ||
    "end";

  const backgroundColor = colorAndOpacityToRGBA(overlayBackgroundColor, overlayOpacity);

  return (
    <div className="slide-overlay padding-xl" style={{ justifyContent, backgroundColor }}>
      {text}
      {button}
    </div>
  );
};

const SlideOverlay_slide = graphql__e9c568b38f902206e746;

export default SlideOverlay;
